import { FC, memo } from 'react';
import Blocks from '../Blocks/Blocks';
import SiteMenu from '../SiteMenu/SiteMenu';
import MedVoxEvents from './MedVoxEvents/MedVoxEvents';

interface Props {
  selectedKey: string;
  updateData: (key: string) => void;
}

const Events: FC<Props> = (props: Props) => {
  return (
    <Blocks
      topBlock={<SiteMenu title="Журнал событий" />}
      mainBlock={<MedVoxEvents showMedVox />}
    />
  );
};

export default memo(Events);
